import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import {
  Button,
  Flex,
  ScrollArea,
  Stack,
  Switch,
  TextInput,
} from "@mantine/core";
import PopOver from "../../../../components/View/PopOver";
import { IconSettings } from "@tabler/icons-react";
import TableDensity from "../configs/TableDensity";
import { searchNormalize } from "../../../../functions/utilFunctions";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { DndContext } from "@dnd-kit/core";
import ColumnsContentItem from "./ColumnsContentItem";
import { useGridApiContext } from "@mui/x-data-grid-pro";

const TableColumnsContent = ({
  columns,
  columnVisibility,
  onColumnCheck,
  hideAll,
  showAll,
  handleClose,
  getColumnActions,
  setEdited
}) => {
  const lang = useLanguage((s) => s.language);
  const apiRef = useGridApiContext();
  const [searchResult, setSearchResult] = useState(columns);
  const [searchText, setSearchText] = useState("");
  const onSearch = (e) => {
    const searchText = e.target.value;
    setSearchText(searchText);
    const results = columns.filter((column) => {
      return searchNormalize(column.headerName).includes(
        searchNormalize(searchText)
      );
    });
    setSearchResult(results);
  };

  const [items, setItems] = useState(columns);

  function handleDragEnd(event) {
    const { active, over } = event;

    if (over) {
      if (active.id !== over.id) {
        const oldIndex = items.findIndex((x) => x.id === active.id);
        const newIndex = items.findIndex((x) => x.id === over.id);


        let newItems = arrayMove(items, oldIndex, newIndex);
        setItems(newItems);

        apiRef.current.setColumnIndex(active.id, newIndex)
        setEdited(true)
      }
    }
  }

  return (
    <Stack gap={0} py={8} pos={"relative"} px={16}>
      <TextInput
        placeholder={lang.table.toolbar.columns.search_placeholder}
        onChange={onSearch}
        variant="unstyled"
        styles={{
          input: {
            paddingLeft: 8,
          },
        }}
        w={"80%"}
        autoFocus
      />
      <Stack mah={360} component={ScrollArea}>
        {
          searchText ?
            searchResult.map((column) => {
              return (
                <Switch
                  label={column.headerName}
                  key={column.id}
                  onChange={(e) => onColumnCheck(column.field, e.target.checked)}
                  checked={columnVisibility[column.field] === false ? false : true}
                  size="sm"
                  mt={8}
                />
              );
            })
            :

            <DndContext onDragEnd={handleDragEnd}>
              <SortableContext items={items} strategy={verticalListSortingStrategy}>
                {items.map((item, index) => {
                  return (
                    <ColumnsContentItem
                      key={item.id}
                      column={item}
                      onCheck={(e) => onColumnCheck(item.field, e.target.checked)}
                      checked={columnVisibility[item.field] === false ? false : true}
                    />
                  );
                })}
              </SortableContext>
              {/* {createPortal(
                <DragOverlay>
                  {activeDrag ? (
                    <ColumnsContentItem
                      key={activeDrag.field}
                      column={activeDrag}
                    />
                  ) : null}
                </DragOverlay>,
                document.body
              )} */}
            </DndContext>
        }
      </Stack>

      <PopOver
        opener={(openFunction, ref) => {
          return (
            <Button
              ref={ref}
              onClick={openFunction}
              radius={"md"}
              variant={"subtle"}
              px={8}
              pos={"absolute"}
              top={8}
              right={8}
            >
              <IconSettings size={18} />
            </Button>
          );
        }}
        popoverChildren={(closePopover) => (
          <Stack pt={3} pos={"relative"} w={200} gap={"xs"}>
            <TableDensity />

            <Button
              size="sm"
              onClick={() => hideAll(closePopover)}
              variant="light"
            >
              {lang.table.toolbar.columns.hide_all}
            </Button>
            <Button
              size="sm"
              onClick={() => showAll(closePopover)}
              variant="light"
            >
              {lang.table.toolbar.columns.show_all}
            </Button>
          </Stack>
        )}
        keepMounted
      />

      <Flex w={"100%"} mt={8}>
        {getColumnActions?.(handleClose)}
      </Flex>

      {/* {pageOrderName && (
        <ColumnsSaver
          columns={columns}
          columnVisibility={columnVisibility}
          pageOrderName={pageOrderName}
        />
      )} */}
    </Stack>
  );
};

export default TableColumnsContent;
